/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_PageInputs */

const ja_home_meta_page = /** @type {(inputs: Home_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`index`)
};

const en_home_meta_page = /** @type {(inputs: Home_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`index`)
};

/**
* | output |
* | --- |
* | "index" |
*
* @param {Home_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_meta_page = /** @type {((inputs?: Home_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_meta_page(inputs)
	return en_home_meta_page(inputs)
});